export class SessionAlreadyStartedError extends Error {
    constructor(message) {
        super(message || 'Sesión ya inicializada');
        this.name = 'SessionAlreadyStartedError';
    }
}
//# sourceMappingURL=session_already_started_error.js.map